import { createSlice } from '@reduxjs/toolkit'
import { Store } from 'builder/modules/store'
import { WorkingTypes } from '../careerProfile'
import { actions as userActions } from '../user/userModule'
import { AutoApplyStore } from './types'
const initialState: AutoApplyStore = {
  form: {
    id: 0,
    firstName: '',
    lastName: '',
    currentJobTitle: '',
    gender: '',
    resumeId: null,
    resumeType: null,
    resumeUrl: '',
    race: '',
    location: '',
    fullAddress: '',
    email: '',
    phoneNumber: '',
    targetRoles: [],
    countriesAuthorizedToWorkIn: [],
    socialLinksAttributes: [
      {
        link: '',
        title: '',
      },
    ],
    jobPreferenceAttributes: {
      currentSalary: undefined,
      currentCurrency: 'USD',
      currentSalaryPlan: 'annually',
      expectedSalary: undefined,
      expectedCurrency: 'USD',
      expectedSalaryPlan: 'annually',
      expectedWorkingTypes: [WorkingTypes.office],
      openForBusinessTrips: false,
      willingToRelocate: false,
      willingToRelocateAtYourOwnCost: false,
      expectedStartWork: 'immediate',
      fullyVaccinatedAgreementAgainstCovid: false,
      hasRestrictionLimiting: false,
      openToRemoteOpportunities: false,
    },
    coursesAttributes: [
      {
        id: undefined,
        course: '',
        dateFrom: '',
        dateUntil: '',
        institution: '',
      },
    ],
    autoApplyDataCompleted: false,
    targetLocations: [],
    workExperiencesAttributes: [],
    selectedCoverLetterId: null,
    autoTailoring: true,
    autoTailoringCl: true,
    resumeUploadedAt: '',
  },
  resumeDistributionForm: {
    jobPreferences: {
      country: undefined,
      state: undefined,
      industry: '',
      remote: 'false',
      salaryCurrency: 'USD',
      salaryAmount: '',
      salaryPeriod: 'year',
    },
    location: {
      country: undefined,
      state: undefined,
      city: undefined,
    },
  },
}

export const selectors = {
  form: (state: Store) => state.autoApply.form,
  resumeDistributionForm: (state: Store) => state.autoApply.resumeDistributionForm,
  isAutoApplyFormCompleted: (state: Store) => state.autoApply.form?.autoApplyDataCompleted,
}

const { reducer, actions } = createSlice({
  name: 'autoApply',
  initialState,
  reducers: {
    updateForm: (state, action) => {
      state.form = { ...state.form, ...structuredClone(action.payload) }
    },
    updateResumeDistributionForm: (state, action) => {
      state.resumeDistributionForm = {
        ...state.resumeDistributionForm,
        ...structuredClone(action.payload),
      }
    },
  },
  extraReducers: builder => {
    builder.addCase(userActions.setAccount, (state, action) => {
      state.form.email = action.payload.user?.email || ''
      state.form.firstName = action.payload.user?.firstName || ''
      state.form.lastName = action.payload.user?.lastName || ''
    })
  },
})

export { reducer, actions }
